import { apiFetch } from "lib/fetch"
import { Thunk } from "lib/hooks"
import { loadPhrases } from "reducers/phrases"

import { handleErrors } from "../error/handler"

export interface ApiPhrase {
  id: string
  modified: string
  name: { [language: string]: string }
  content?: { [language: string]: string }
  parentId?: string
}

export const fetchPhrasesData =
  (selectedClinicId: string | undefined): Thunk =>
  dispatch => {
    const getPhrasesUrl = (selectedClinicId: string | undefined) =>
      selectedClinicId ? `/v2/phrases?is_clinic=true&clinic_id=${selectedClinicId}` : "/v2/phrases?is_clinic=false"

    return dispatch(apiFetch(getPhrasesUrl(selectedClinicId)))
      .then((response: { phrases: ApiPhrase[] }) => dispatch(loadPhrases(response.phrases)))
      .catch((error: any) => dispatch(handleErrors({ error })))
  }
